import { ModalService } from './../../services/modal.service';
import { Component, OnInit, HostListener} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {DGB, MENU_PATH} from "src/app/shared/constants/common.const";
import { Util } from "src/app/shared/helpers/util";
import { REG1100Component } from "src/app/modules/com/register/reg1100/reg1100.component";
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-layout-common',
  templateUrl: './layout-common.component.html',
  styleUrls: ['./layout-common.component.css']
})
export class LayoutCommonComponent implements OnInit {

  menuPath = MENU_PATH;
  util = new Util();
  viewText: any;
  isLogin: boolean = null;
  isRegister: boolean = null;
  langCode = this.translate.currentLang;
  isSession: any;
  langData = {
    en: { class: "eng", text: "English" },
    km: { class: "khmer", text: "ខ្មែរ" },
  };

  constructor(
    private translate: TranslateService,
    private modalService: ModalService,
    private authService: AuthService
  ) {
    this.translate = translate;
  }

  ngOnInit() {
    this.isActivePage();
    this.langCode = this.util.getSecureStorage("langCode") || "en";
    this.translate.use(this.langCode);

    if ( this.authService.hasSession() ) {
      this.isSession = this.authService.hasSession();
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    if ( location.pathname === '/register' ) {
      this.isRegister = true;
      this.isLogin = false;
    } else if ( location.pathname === '/login' ) {
        this.isRegister = false;
        this.isLogin = true;
    }
  }

  onClickLoginPage(){
    this.isRegister = true;
    this.isLogin = false;
  }

  onClickRegisterPage(){
    this.isLogin = true;
    this.isRegister = false;
  }

  isActivePage() {
    if ( location.pathname === '/register' ) {
      this.isRegister = true;
    } else if ( location.pathname === '/login' ) {
       this.isLogin = true;
    }
  }

  onChangeLanguage( code: string ) {
    this.langCode = code;
    this.translate.use( this.langCode );
    this.util.setSecureStorage( "langCode", this.langCode );
  }

  onTrackStatus(){
    this.modalService.open( {
      content: REG1100Component
    } );
  }

  onClickLogo(){
    window.open( DGB.MAIN, "_blank" );
  }
}
